import { useTranslation } from "react-i18next";

function LegalPage({ tKey, sectionKeys, testid }) {
  const { t } = useTranslation();
  return (
    <article
      className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16"
      data-testid={testid}
    >
      <p className="text-xs uppercase tracking-widest text-slate-500">
        {t(`${tKey}.updated`)}
      </p>
      <h1
        className="mt-3 text-4xl sm:text-5xl text-slate-900"
        style={{ fontFamily: "Merriweather, serif", fontWeight: 700 }}
      >
        {t(`${tKey}.title`)}
      </h1>
      <p className="mt-6 text-slate-700 leading-relaxed">{t(`${tKey}.intro`)}</p>

      <div className="mt-10 space-y-8">
        {sectionKeys.map((k) => (
          <section key={k}>
            <h2
              className="text-xl text-slate-900"
              style={{ fontFamily: "Merriweather, serif", fontWeight: 700 }}
            >
              {t(`${tKey}.sections.${k}.title`)}
            </h2>
            <p className="mt-3 text-slate-700 leading-relaxed">
              {t(`${tKey}.sections.${k}.body`)}
            </p>
          </section>
        ))}
      </div>
    </article>
  );
}

export function PrivacyPage() {
  return (
    <LegalPage
      tKey="privacy"
      testid="privacy-page"
      sectionKeys={[
        "responsible",
        "data",
        "purpose",
        "retention",
        "rights",
        "transfer",
        "security",
      ]}
    />
  );
}

export function CookiesPage() {
  return (
    <LegalPage
      tKey="cookies"
      testid="cookies-page"
      sectionKeys={["what", "types", "consent", "third_party", "duration"]}
    />
  );
}

export function TermsPage() {
  return (
    <LegalPage
      tKey="terms"
      testid="terms-page"
      sectionKeys={["acceptance", "services", "ip", "liability", "law", "contact"]}
    />
  );
}
